import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { MdwButton } from '@spaces-ui/meadow/components/button';
import { MdwDialogService } from '@spaces-ui/meadow/components/dialog';

import { BAMDialog, SimpleFormDialog } from './sample-dialogs';
import { Sample } from '../../components';

@Component({
  selector: 'app-dialogs',
  imports: [Sample, MdwButton],
  templateUrl: './dialogs.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dialogs.scss',
})
export class Dialogs {
  //#region sample:alertDialog
  public dialogService = inject(MdwDialogService);
  public triggerAlert(useDanger = false) {
    if (useDanger) {
      this.dialogService.alertDanger('Hello, World!', 'Hello Scary World', 'Done!');
    } else {
      this.dialogService.alert('Hello, World!', 'Hello', 'Got it!');
    }
  }
  //#endregion

  //#region sample:confirmationDialog
  public triggerConfirmationDialog(useDanger = false) {
    this.dialogService.confirm({
      title: 'Are you sure?',
      message: 'This action cannot be undone.',
      primaryButton: useDanger ? undefined : 'Yes',
      secondaryButton: 'No',
      dangerButton: useDanger ? 'Delete' : undefined,
    });
  }
  //#endregion

  //#region sample:simpleFormDialog
  public triggerSimpleFormDialog() {
    this.dialogService.open(SimpleFormDialog, {});
  }
  //#endregion

  //#region sample:bamDialog
  public triggerBamDialog() {
    this.dialogService.openBAM(BAMDialog);
  }
  //#endregion
}
